  <app-strategy-map-form (close)="closeModal()" *ngIf="isFormVisible"></app-strategy-map-form>

  <app-strategy-map-recipients (close)="closeModal()" *ngIf="isRecipientsVisible"></app-strategy-map-recipients>
  
  <app-strategy-map-confirm (close)="closeModal()" *ngIf="isConfirmVisible"></app-strategy-map-confirm>
